module.exports = __webpack_public_path__ + "img/MCMUG25-b.5066e70d.png";